import React from 'react';
import './booking-mangement-content.css'
import AddCTA from '../component/common/addcta';
import pic24 from '../assets/pic24.png'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic29 from '../assets/pic29.png'
import Header2 from '../component/common/title';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Input from '../component/common/input';
import Cta from '../component/common/cta';
import pic30 from '../assets/pic30.png'
import Textarea from '../component/common/textarea';
import Selectinput from '../component/common/selectinput';
import pic31 from '../assets/pic31.png'
import SubpageCTA from '../component/common/subpagecta';
import pic33 from '../assets/pic33.png'
import pic34 from '../assets/pic34.png'
import Ticketnum from '../component/common/ticketnumb';
import Errormsginput from '../component/common/errormsginput';

const Bookingcontent = () => {


const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 6;

const [paymentMethod, setPaymentMethod] = useState("card");
const [agreeTerms, setAgreeTerms] = useState(false);

         const [booking, setBooking]= useState([]);

        useEffect(() => {
        const getbooking = async()=>{
            const res = await supabase.from('bookings').select(`
        id,
        booking_date,
        quantity,
        total_price,
        status,
        created_at,
        updated_at,

        user_id,
        ticket_id,
        event_id,

        users (
        user_name,
        user_email,
        address,
        phone,
        job_title,
        company_name
        ),

        ticket (
        name,
        price
        ),

        exbition_event (
        event_name
        )
      `).order('id', { ascending: true });;
        setBooking(res.data);
        }
        getbooking();
        }, []);




// el hyta deh ly el filter we sort we search


const filteredBooking = booking
  .filter((item) => {
    const searchValue = search.toLowerCase();

    return (
      item?.users?.user_name
        ?.toLowerCase()
        .includes(searchValue) ||

      item?.users?.user_email
        ?.toLowerCase()
        .includes(searchValue) ||

      item?.exbition_event?.event_name
        ?.toLowerCase()
        .includes(searchValue) ||

      item?.ticket?.name
        ?.toLowerCase()
        .includes(searchValue)
    );
  })

  .filter((item) => {
    if (!filter) return true;

    return item.status?.toLowerCase() === filter.toLowerCase();
  })

    .sort((a, b) => {

    if (sort === "newbooking") {
        return new Date(b.created_at) - new Date(a.created_at);
    }

    if (sort === "oldbooking") {
        return new Date(a.created_at) - new Date(b.created_at);
    }

    if (sort === "recentupdate") {
        return new Date(b.updated_at) - new Date(a.updated_at);
    }

    if (sort === "highprice") {
        return b.total_price - a.total_price;
    }

    if (sort === "lowprice") {
        return a.total_price - b.total_price;
    }

    return 0;
    })


    // dah ly el pages bta3t el tablee


useEffect(() => {
  setCurrentPage(1);
}, [search, filter, sort]);

const totalPages = Math.ceil(filteredBooking.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const currentBookings = filteredBooking.slice(startIndex, endIndex);




// this is my deleete function
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);

const confirmDelete = async () => {
  const id = selectedDeleteId;

  await supabase.from('bookings').delete().eq('id', id);

  setBooking(prev => prev.filter(event => event.id !== id));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};












// this is the begaining of edittttt and createeee


const [open, setOpen] = useState(false);

const [form, setForm] = useState({
  user_name: "",
  user_email: "",
  phone: "",
  job_title: "",
  company_name: "",
  booking_date: "",
  quantity: 1,
    address: "", 
  status: "pending",
  total_price: 0,
  user_id: "",
  ticket_id: "",
  event_id: "",
    card_placeholder: "",
    card_number: "", 
  expire_date: "",
  cvv: ""
});

const [errors, setErrors] = useState({});




const [editingId, setEditingId] = useState(null);
const isEdit = !!editingId;

const [users, setUsers] = useState([]);
const [tickets, setTickets] = useState([]);
const [events, setEvents] = useState([]);

useEffect(() => {
  const fetchData = async () => {

    const usersRes = await supabase.from("users").select("id, user_name, user_email, phone, job_title, company_name, address");
     const ticketsRes = await supabase.from("ticket").select("id, name, price");
    const eventsRes = await supabase.from("exbition_event").select("id, event_name, start_date, end_date, status");;

    setUsers(usersRes.data || []);
      setTickets(ticketsRes.data || []);
    setEvents(eventsRes.data || []);
  };

  fetchData();
}, []);







useEffect(() => {
  const selectedTicket = tickets.find(
    t => String(t.id) === String(form.ticket_id)
            );
      if (!selectedTicket) return;
  const qty = Number(form.quantity || 1);

  setForm(prev => ({
      ...prev,
    total_price: selectedTicket.price * qty }));
}, [form.ticket_id, form.quantity, tickets]);













const handleSubmit = async (e) => {
  e?.preventDefault();

const newErrors = {};

      if (!form.user_name) {
        newErrors.user_name = "Name is required";}

      if (!form.user_email) {
        newErrors.user_email = "Email is required";} else if (!/\S+@\S+\.\S+/.test(form.user_email)) {
        newErrors.user_email = "Invalid email format"; }


   
        if (!form.booking_date) {
          newErrors.booking_date = "Date is required";}

      if (!form.ticket_id) {
        newErrors.ticket_id = "Ticket is required"; }

      
      if (!isEdit) {
          if (!form.phone) newErrors.phone = "Phone is required";
        if (!form.card_placeholder) newErrors.card_placeholder = "Card placeholder is required";
            if (!form.card_number) newErrors.card_number = "Card number is required";
           if (!form.expire_date)  newErrors.expire_date = "Expire date is required";
        if (!form.cvv) newErrors.cvv = "CVV is required";
           if (!agreeTerms)  newErrors.agree= "You must agree to terms";
      }

setErrors(newErrors);

        const hasErrors = newErrors.user_name || newErrors.user_email ||
                          newErrors.booking_date || newErrors.ticket_id ||
                          (!isEdit && (newErrors.phone || newErrors.card_placeholder ||
                                      newErrors.card_number || newErrors.expire_date ||
                                      newErrors.cvv || newErrors.agree));

        if (hasErrors) return;






//   Dah 3alshan el users a3mlhom create we kda
let userId = form.user_id;
    if (!userId) {
      const { data: newUser, error: userError } = await supabase
        .from("users")
        .insert([
        {
            user_name: form.user_name,
            user_email: form.user_email,
            phone: form.phone,
            job_title: form.job_title,
                 address: form.address,
            company_name: form.company_name
        }
        ])
        .select()
        .single();

      if (userError) {
        console.log("USER ERROR:", userError.message);
        return;
      }

      userId = newUser.id;
    } else {
      const { error: updateUserError } = await supabase
        .from("users")
            .update({
            user_name: form.user_name,
             user_email: form.user_email,
            phone: form.phone,
                 address: form.address,
            job_title: form.job_title,
            company_name: form.company_name
            })
        .eq("id", userId);

      if (updateUserError) {
        console.log("USER UPDATE ERROR:", updateUserError.message);
        return;
      }
    }



    // dah ly el bookingggggg 
    const payload = {
      booking_date: form.booking_date,
      quantity: Number(form.quantity),
      status: form.status,
      total_price: Number(form.total_price),
      user_id: userId,
      ticket_id: form.ticket_id,
      event_id: form.event_id
    };

    let res;

    if (editingId !== null) {
      res = await supabase
        .from("bookings")
        .update(payload)
        .eq("id", editingId);
    } else {
      res = await supabase
        .from("bookings")
        .insert([payload]);
    }

    if (res.error) {
      console.log("BOOKING ERROR:", res.error.message);
      return;
    }




    // Dah 3alshan el refreshhh 
    const { data } = await supabase
      .from("bookings")
      .select(`
        id,
        booking_date,
        quantity,
        total_price,
        status,
        user_id,
        ticket_id,
        event_id,
        users (user_name, user_email),
        ticket (name, price),
        exbition_event (event_name)
      `)
      .order("id", { ascending: true });

    setBooking(data || []);





    //3alshan a reset el hagat

    setErrors({});
    setOpen(false);
    setEditingId(null);

    setForm({
      user_name: "",
      user_email: "",
      booking_date: "",
      quantity: 1,
      status: "pending",
      total_price: 0,
      user_id: "",
      ticket_id: "",
      event_id: ""
    });

};










const selectedEvent = events.find(
  (event) => event.id == form.event_id
);

const bookingDateOptions = [];

if (selectedEvent) {
  const start = new Date(selectedEvent.start_date);
  const end = new Date(selectedEvent.end_date);

  let current = new Date(start);

  while (current <= end) {
    bookingDateOptions.push({
      value: current.toISOString().split("T")[0],
      label: current.toISOString().split("T")[0]
    });

    current.setDate(current.getDate() + 1);
  }
}




















    return ( 

    <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Bookings Management"  
                            para="Manage all exhibition bookings and tickets"
                            />
                            
                          <AddCTA    title='Add Booking' 
                            onClick={() => {
                                    const ongoingEvent = events.find(
                                (event) => event.status === "ongoing"
                                );

                                       setForm({
                                      user_name: "",       
                                      user_email: "",      
                                      phone: "",           
                                      job_title: "",     
                                      company_name: "",   
                                      address: "",       
                                      card_placeholder: "", 
                                      card_number: "",     
                                      expire_date: "",   
                                      cvv: "",             
                                      booking_date: "",
                                      quantity: 1,
                                      status: "pending",
                                      total_price: 0,
                                      user_id: "",
                                      ticket_id: "",
                                      event_id: ongoingEvent?.id || ""
                                    });
                                    setEditingId(null);
                                 
                                    setOpen(true);
                                    }}
                                />
                     
                            {open && (
                                <form className="overlay-create" onSubmit={handleSubmit}>
                                    <fieldset className="container-create">

                                    <div class="header-create">
                                        <h1 className="title-create">
                                        {isEdit ? "Edit Booking" : "Add New Booking"}
                                        </h1>
                                        <button className="close-btn-create" type="button" 
                                        onClick={() => {
                                            setOpen(false);
                                            setEditingId(null);
                                            }}>
                                        <img alt="close" src={pic30}/></button>
                                        </div>


                                    
                                    <Selectinput
                                        title="Choose Event"
                                         value={form.event_id}
                                        onChange={(e) =>
                                         setForm({ ...form, event_id: e.target.value })
                                        }
                                        options={events.map(e => ({
                                        value: e.id,
                                         label: e.event_name
                                        }))}
                                    />
                                    
                                        <Input
                                        title="User Name"
                                        placeholder={isEdit ? "" : "Enter User Name"}
                                        value={form.user_name}
                                        onChange={(e) =>
                                            setForm({ ...form, user_name: e.target.value })
                                        }
                                        />
                                        <Errormsginput message={errors.user_name} />

                                        <Input
                                        title="User Email"
                                        placeholder={isEdit ? "" : "Enter User Email"}
                                         value={form.user_email}
                                        onChange={(e) =>
                                            setForm({ ...form, user_email: e.target.value })
                                        }
                                        />
                                        <Errormsginput message={errors.user_email} />

                                        <Selectinput
                                        title="Choose Date"
                                        value={form.booking_date}
                                         onChange={(e) =>
                                            setForm({
                                            ...form,
                                            booking_date: e.target.value
                                            })
                                        }
                                        options={bookingDateOptions}
                                        />
                                        <Errormsginput message={errors.booking_date} />

                                        <Ticketnum
                                        title="Quantity"
                                        value={form.quantity}
                                        onChange={(val) =>
                                            setForm({ ...form, quantity: val })
                                        }
                                        />
                                       


                                    <Selectinput
                                        title="Choose Ticket"
                                          value={form.ticket_id}
                                        onChange={(e) =>
                                            setForm({ ...form, ticket_id: e.target.value })
                                        }
                                        options={tickets.map(t => ({
                                            value: t.id,
                                            label: `${t.name} - ${t.price} EGP`
                                        }))}
                                        />
                                         <Errormsginput message={errors.ticket_id} />
                            {!isEdit && (
                                    <>
                                        <Input
                                        title="Phone"
                                        placeholder="Enter Phone"
                                        value={form.phone}
                                        onChange={(e) =>
                                            setForm({ ...form, phone: e.target.value })
                                        }
                                        />
                                        <Errormsginput message={errors.phone} />

                                        <Input
                                        title="Job Title"
                                        placeholder="Enter Job Title"
                                        value={form.job_title}
                                        onChange={(e) =>
                                            setForm({ ...form, job_title: e.target.value })
                                        }
                                        />

                                        <Input
                                        title="Company Name"
                                         placeholder="Enter Company Name"
                                        value={form.company_name}
                                        onChange={(e) =>
                                            setForm({ ...form, company_name: e.target.value })
                                        }
                                        />

                                        <Input
                                        title="Address"
                                        placeholder="Enter Address"
                                        value={form.address}
                                        onChange={(e) =>
                                            setForm({ ...form, address: e.target.value })
                                        }
                                        />



                                        <Selectinput
                                            title="Payment Method"
                                            value={paymentMethod}
                                            onChange={(e) => setPaymentMethod(e.target.value)}
                                            options={[
                                                { value: "card", label: "Credit Card" },
                                                { value: "paypal", label: "PayPal" }
                                            ]}
                                            />

                                            {paymentMethod === "card" && (
                                            <>
                                                <Input title="Card Placeholder" placeholder="Card Holder Name"
                                                  value={form.card_placeholder}
                                              onChange={(e) =>
                                                setForm({ ...form, card_placeholder: e.target.value })
                                              }/>

                                              <Errormsginput message={errors.card_placeholder} />
                                                
                                                <Input title="Card Number" placeholder="1234 5678 9012 3456" 
                                                value={form.card_number}
                                                  onChange={(e) =>
                                                    setForm({ ...form, card_number: e.target.value })
                                                  }
                                                />

                                                <Errormsginput message={errors.card_number} />




                                                <Input title="Expire Date" placeholder="MM/YY" 
                                                  value={form.expire_date}
                                                    onChange={(e) =>
                                                      setForm({ ...form, expire_date: e.target.value })
                                                    }
                                                  />

                                                  <Errormsginput message={errors.expire_date} />


                                                <Input title="CVV" placeholder="123"
                                                      value={form.cvv}
                                                      onChange={(e) =>
                                                        setForm({ ...form, cvv: e.target.value })
                                                      }
                                                    />

                                                    <Errormsginput message={errors.cvv} />
                                            </>
                                            )}


                                           
                                            <label class="custom-checkbox">
                                                <input className='checkbox-whitee-book' type="checkbox"   checked={agreeTerms} onChange={(e) => setAgreeTerms(e.target.checked)}/>
                                                <span class="checkmark"></span>I agree to the terms
                                                </label>
                                          <Errormsginput message={errors.agree} />
                                    </>
                                    )}






                                         {isEdit && (
                                            <Selectinput
                                                title="Status"
                                                value={form.status}
                                                onChange={(e) =>
                                                setForm({ ...form, status: e.target.value })}
                                                options={[
                                                { value: "pending", label: "Pending" },
                                                { value: "confirmed", label: "Confirmed" },
                                                { value: "cancelled", label: "Cancelled" }   ]} />)}


                                    <nav className='container-ctas-craete'>
                                           <Cta
                                            title={editingId ? "Update Event" : "Save Event"}
                                            className="cta-create"
                                         type="submit"
                                    />

                                            <button className='cta-cancel-create' onClick={() => {
                                            setOpen(false);
                                            setEditingId(null);
                                            }}>
                                            <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                            </button>
                                    </nav>
                                    </fieldset>
                                </form>
                                )}  

                                
                                  
        </article>




         <section className='container-table2-eventp'>                    




                                    <section className='container-sub-pages-part'>
                                        <nav className='container2-sub-pages-cta'>
                                            <button className='main-container-cta-subpage'>
                                                <SubpageCTA title='Booking-Users' img={pic33} alt='booking-users'
                                                style2='cta-event-text' style1='subpagecta-event'/>
                                            </button>
                                            <button className='main-container-cta-subpage'>
                                                <SubpageCTA title='Booking-companies' img={pic34} alt='booking-companies'
                                                style2='secsubpagecta-event-text' style1='secsubpagecta-event'/>
                                            </button>
                                        </nav>
                                    </section>











          <section className='container-table-eventp'>



                                        {showDeleteModal && (
                                                <section className="delete-modal-overlay">
                                                    <article className="delete-modal">

                                                    <header className="delete-modal-header">
                                                        <div className="delete-icon-wrapper">
                                                        <img src={pic31} alt='icon' />
                                                        </div>

                                                        <div className="delete-text-container">
                                                        <h2 className="delete-title">Delete Booking</h2>
                                                        <p className="delete-description">
                                                            Are you sure you want to delete this Booking?
                                                        </p>
                                                        </div>
                                                    </header>

                                                    <nav className="container-ctas-craete">

                                                       <Cta 
                                                         onClick={confirmDelete}
                                                        title='Delete'
                                                       className="cta-create"
                                                       type="button" />

                                                    <button className='cta-cancel-create' 
                                                    onClick={() => {
                                                                        setShowDeleteModal(false);
                                                                        setSelectedDeleteId(null);
                                                    }}>
                                                    <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                                    </button>
                                                              
                                                                
                                                    </nav>

                                                    </article>
                                                </section>
                                                )} 





                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search bookings..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic26} className="search-icon" alt="search" />
                            </fieldset>

                            <fieldset className='container-inputs-event-p'>
                                    <div className="select-wrapper">
                                                <img src={pic25} className="arrow-icon" alt="arrow" />
                                                <img src={pic26} className="select-icon" alt="filter" />
                                           <select
                                            className="input-search select-style"
                                            value={filter}
                                            onChange={(e) => setFilter(e.target.value)}
                                            >
                                            <option value="">Filter by</option>
                                            <option value="pending">Pending</option>
                                            <option value="confirmed">Confirmed</option>
                                            <option value="cancelled">Cancelled</option>
                                            </select>
                                     </div>

                                    <div className="select-wrapper">
                                        <img src={pic25} className="arrow-icon" alt="arrow" />
                                        <img src={pic24} className="select-icon" alt="sort" />
                                     <select
                                        className="input-search select-style"
                                        value={sort}
                                        onChange={(e) => setSort(e.target.value)}
                                        >
                                        <option value="">Sort by</option>
                                        <option value="newbooking">New Bookings</option>
                                        <option value="oldbooking">Old Bookings</option>
                                        <option value="recentupdate">Recently Updated</option>
                                        <option value="highprice">Highest Price</option>
                                        <option value="lowprice">Lowest Price</option>
                                        </select>
                                    </div>

                            </fieldset>



                             <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>User Name</th>
                                        <th className='table-header-text'>User Email</th>
                                        <th className='table-header-text'>Date</th>
                                        <th className='table-header-text'>Event Name</th>                                        
                                        <th className='table-header-text'>Quantity</th>
                                        <th className='table-header-text'>Status</th>
                                        <th className='table-header-text'>Ticket Type</th>                                        
                                        <th className='table-header-text'>Ticket price</th>
                                        <th className='table-header-text'>Total price</th>                                                                                                                                                                                                                                          
                                        <th className='table-header-text'>Actions</th>
                                    </tr>
                                    </thead>

                                {currentBookings.map((item) => (
                                    <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox"  className='checkboxxx'/>
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                <td className='mainwhite-table-font'>
                                                   {item.users?.user_name}
                                                </td>
                                                <td className='mainwhite-table-font'>  {item.users?.user_email}</td>
                                                 <td className='mainwhite-table-font'>
                                                  {item.booking_date}
                                                </td>
                                                 <td className='container-event-desc-long'>
                                                   {item.exbition_event?.event_name}
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                     {item.quantity}
                                                </td>
                                                 <td className="container-event-desc">
                                                <p className="truncate-text">
                                                  {item.status}
                                                </p>
                                                </td>
                                                <td className="container-event-desc">
                                                <p className="truncate-text">
                                                     {item.ticket?.name}
                                                </p>
                                                </td>

                                                <td className='mainwhite-table-font'>
                                                   {item.ticket?.price}EGP
                                                </td>

                                                <td className='mainwhite-table-font'>
                                                    {item.total_price}EGP
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>

                                                            <button
                                                            className='cta2-table'
                                                            
                                                            >
                                                                <img src={pic27} alt='VIEW' />
                                                            </button>


                                                            <button
                                                            className='cta2-table'
                                                           onClick={() => {
                                                            setEditingId(String(item.id));

                                                            setForm({
                                                             user_name: item.users?.user_name || "",
                                                                user_email: item.users?.user_email || "",
                                                                phone: item.users?.phone || "",
                                                                job_title: item.users?.job_title || "",
                                                                company_name: item.users?.company_name || "",
                                                                address: item.users?.address || "",
                                                                booking_date: item.booking_date || "",
                                                                quantity: item.quantity || 1,
                                                                status: item.status || "pending",
                                                                total_price: item.total_price || 0,
                                                                user_id: item.user_id || "",
                                                                ticket_id: item.ticket_id || "",
                                                                event_id: item.event_id || "",

                                                                card_placeholder: "",
                                                                card_number: "",
                                                                expire_date: "",
                                                                cvv: ""
                                                            });

                                                            setOpen(true);
                                                            }}
                                                            >
                                                            <img src={pic28} alt='edit' />
                                                            </button>
                                                            


                                                            <button
                                                            className='cta2-table'
                                                             onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                               setShowDeleteModal(true);
                                                            }}>
                                                                <img src={pic29} alt='delete' />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
                                  ))}
                                </table>
                                </div>

                                    


            </section>


                            <nav className="pagination-container">

                            <button
                                className="pagination-btn"
                                disabled={currentPage === 1}
                                onClick={() => setCurrentPage(currentPage - 1)}>
                                Prev
                            </button>

                            <section className="pagination-numbers">

                                {[...Array(totalPages)].map((_, index) => ( <button
                                    key={index}
                                    className={
                                    currentPage === index + 1
                                        ? "pagination-number active-page"
                                        : "pagination-number"}
                                    onClick={() => setCurrentPage(index + 1)}>
                                    {index + 1}</button>
                                ))}

                            </section>

                            <button
                                className="pagination-btn"
                                disabled={currentPage === totalPages}
                                onClick={() => setCurrentPage(currentPage + 1)}>
                                Next
                            </button>

                            </nav>




            </section>   


    </section>
    );
}
 
export default Bookingcontent;